import { Link } from 'react-router-dom';
import { mainCategories } from '@/mocks/categories';

const services = [
  {
    icon: 'ri-film-line',
    title: '影视资源展示',
    desc: '覆盖科幻、悬疑、剧情、纪录片等多元类型，提供封面、简介、评分与更新状态等完整信息。',
  },
  {
    icon: 'ri-video-line',
    title: '高清视频聚合',
    desc: '短视频与直播专区内容集中呈现，支持分类筛选与全文搜索，快速定位想看的内容。',
  },
  {
    icon: 'ri-chat-smile-2-line',
    title: '轻量社交互动',
    desc: '围绕影视话题分享观后感、讨论剧情与交换片单，营造轻松友好的交流氛围。',
  },
];

const notices = [
  '本站内容均为前端演示示例，不提供真实视频播放与资源下载服务。',
  '站内所有影视、视频名称与简介均为示例数据，仅用于界面展示。',
  '收藏与发帖功能为界面演示交互，不会真实保存数据，也不会对外发布。',
  '请遵守相关法律法规，理性、健康地浏览与使用本平台。',
];

export default function AboutPage() {
  return (
    <div className="mx-auto w-full px-4 py-8 md:px-6">
      <nav className="flex items-center gap-2 text-sm text-foreground-400">
        <Link to="/" className="transition-colors hover:text-primary-600">
          首页
        </Link>
        <i className="ri-arrow-right-s-line" />
        <span className="text-foreground-700">关于我们</span>
      </nav>

      <section className="mt-6 grid grid-cols-1 items-center gap-10 rounded-lg border border-background-200/70 bg-background-50 p-6 md:grid-cols-2 md:p-10">
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
            <i className="ri-movie-2-line" />
            品牌介绍
          </span>
          <h1 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-900 md:text-3xl">
            麻豆精品入口蜜桃
          </h1>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            麻豆精品入口蜜桃是一个多元化综合娱乐资源平台，聚焦影视视频资源、娱乐内容分类展示与轻量社交互动。
            我们希望用「现代门户 + 专业资料」的浏览方式，把丰富的内容组织得清晰、有序、好找，
            让喜爱影视与高清视频的用户都能轻松找到感兴趣的内容并参与讨论。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/category/movie"
              className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-play-circle-line text-lg" />
              浏览影视分类
            </Link>
            <Link
              to="/community"
              className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              前往社区
            </Link>
          </div>
        </div>
        <div className="grid grid-cols-3 gap-3">
          {mainCategories.map((cat) => (
            <div
              key={cat.slug}
              className="flex flex-col items-center gap-2 rounded-lg border border-background-200/70 bg-background-100 p-4 text-center"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                <i className={`${cat.icon} text-xl`} />
              </span>
              <span className="text-sm font-medium text-foreground-700">{cat.name}</span>
            </div>
          ))}
        </div>
      </section>

      <section className="mt-12">
        <h2 className="font-heading text-xl font-bold text-foreground-900 md:text-2xl">我们提供什么</h2>
        <p className="mt-2 text-sm text-foreground-500">围绕内容展示与浏览体验，平台提供以下核心服务。</p>
        <div className="mt-6 grid grid-cols-1 gap-5 md:grid-cols-3">
          {services.map((s) => (
            <div key={s.title} className="rounded-lg border border-background-200/70 bg-background-50 p-6">
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                <i className={`${s.icon} text-2xl`} />
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-900">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-500">{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-3">
        <div className="rounded-lg border border-background-200/70 bg-background-50 p-6 lg:col-span-1">
          <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-900">
            <i className="ri-contacts-line text-primary-500" />
            联系方式
          </h2>
          <div className="mt-4 flex flex-col gap-4 text-sm">
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-100 text-foreground-500">
                <i className="ri-mail-line" />
              </span>
              <div>
                <p className="text-xs text-foreground-400">商务与合作邮箱（演示）</p>
                <p className="text-foreground-700">contact@madou-mitao.com</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-100 text-foreground-500">
                <i className="ri-customer-service-2-line" />
              </span>
              <div>
                <p className="text-xs text-foreground-400">内容反馈（演示）</p>
                <p className="text-foreground-700">support@madou-mitao.com</p>
              </div>
            </div>
          </div>
        </div>

        <div className="rounded-lg border border-background-200/70 bg-background-50 p-6 lg:col-span-2">
          <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-900">
            <i className="ri-information-line text-primary-500" />
            用户须知
          </h2>
          <ul className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
            {notices.map((n) => (
              <li key={n} className="flex items-start gap-2 text-sm leading-relaxed text-foreground-600">
                <i className="ri-checkbox-circle-line mt-0.5 text-secondary-500" />
                {n}
              </li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  );
}